import { RouteObject } from 'react-router-dom';
import Landing from './components/Landing';

export interface DashboardRoute extends Omit<RouteObject, 'children'> {
  auth?: boolean;
  children?: DashboardRoute[];
}

export const dashboardRoutes: DashboardRoute[] = [
  {
    path: '/dashboard',
    element: <Landing />,
    auth: false,
  }
];
